import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { getFunctions, httpsCallable } from 'firebase/functions'

const fns = getFunctions(undefined, 'us-central1')
const completePasswordReset = httpsCallable(fns, 'completePasswordReset')

export default function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [password, setPassword] = React.useState('')
  const [confirmPassword, setConfirmPassword] = React.useState('')
  const [busy, setBusy] = React.useState(false)
  const [err, setErr] = React.useState('')
  const [ok, setOk] = React.useState(false)

  async function submit(e) {
    e.preventDefault()
    setErr('')

    if (!token) {
      setErr('This reset link is missing its security token. Please request a new link.')
      return
    }
    if (password.length < 8) {
      setErr('Password must be at least 8 characters.')
      return
    }
    if (password !== confirmPassword) {
      setErr('Password and confirmation do not match.')
      return
    }

    try {
      setBusy(true)
      await completePasswordReset({ token, password })
      setOk(true)
      setPassword('')
      setConfirmPassword('')
    } catch (e2) {
      setErr(e2?.message || 'Failed to reset password. Please request a new link.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        boxSizing: 'border-box',
        pointerEvents: 'auto'
      }}
    >
      <div className="card" style={{ maxWidth: 420, width: '100%', margin: 0 }}>
        <h1 style={{ marginTop: 0, textAlign: 'center', fontSize: 32 }}>
          MaintainIQ
        </h1>
        <h2 style={{ marginTop: 0 }}>Set New Password</h2>

        {ok ? (
          <div>
            <div
              style={{
                background: '#e6f4ea',
                border: '1px solid #c7ebd1',
                color: '#1e7e34',
                padding: '10px 12px',
                borderRadius: 10,
                marginBottom: 12
              }}
            >
              Your password has been reset. You can sign in with your new password now.
            </div>
            <Link className="btn primary" to="/signin">
              Go to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="grid1" style={{ gap: 12 }}>
            {err && (
              <div
                style={{
                  background: '#fdecea',
                  border: '1px solid #f5c2c0',
                  color: '#b3261e',
                  padding: '10px 12px',
                  borderRadius: 10
                }}
              >
                {err}
              </div>
            )}

            <p className="muted" style={{ marginTop: 0 }}>
              Enter a new password for your account. This secure link expires after 30 minutes.
            </p>

            <div>
              <label>New Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>
            <div>
              <label>Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>

            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 16, flexWrap: 'wrap' }}>
              <button type="submit" className="btn primary" disabled={busy}>
                {busy ? 'Saving…' : 'Set Password'}
              </button>
              <Link to="/signin" className="btn secondary">
                Back to Sign In
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
